import React from 'react'
import { motion } from 'framer-motion'

import Magazines from '../../Magazines/Magazines'
import { fadeIn } from '../../utils/motion'
import profile from '../../Assets/profile.png'
import { heroImg } from '../../Constants'
import circle from '../../Assets/circle.svg'

const Header = () => {
  return (
    <div className='flex flex-col lg:flex-row gap-6 justify-between relative mt-32'>
      <motion.div
        whileInView={{ x: [-200, 0], opacity: [0, 1] }}
        transition={{ duration: 1 }}
        className='bg-white dark:bg-black_200 h-fit shadow-lg px-8
          py-4 rounded-lg'
      >
        <div className='badge-cmp app__flex'>
          <span className=''>👋</span>
          <div className='ml-10'>
            <p className='sm:text-[18px] text-[14px] text-gray-500 dark:text-secondary tracking-wider uppercase'>
              Hello, I'm{' '}
            </p>
            <h4 className=' dark:text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px] text-black'>
              christsanctus.
            </h4>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1], zIndex: [-3, 1] }}
        transition={{ duration: 1, delayChildren: 1 }}
        className='relative w-full lg:w-fit flex justify-center items-center'
      >
        <img src={profile} alt='profile' className='h-[560px] object-cover' />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 2, ease: 'easeInOut' }}
          className='absolute top-0 z-[-1] w-[400px] m560:w-[600px]'
          src={circle}
          alt='profile-circle'
        />
      </motion.div>
      <section className='flex flex-row lg:flex-col'>
        {[heroImg.react, heroImg.mredux, heroImg.sass].map((item, i) => (
          <motion.div
            variants={fadeIn('left', 'spring', i * 0.5, 0.85)}
            className='p-4 shadow-lg bg-white dark:bg-tertiary rounded-full w-fit h-fit flex justify-center items-center'
            key={`circle-${i}`}
          >
            <img
              src={item}
              alt='items'
              className={`${i === 0 && 'w-20'} ${i === 1 && 'w-52'} ${
                i === 2 && 'w-32'
              } shadow-lg rounded-full object-contain p-1`}
            />
          </motion.div>
        ))}
      </section>
    </div>
  )
}

export default Magazines(Header, 'home')
